import React from "react";
import Navbar from "./Navbar";

const Header = () => {
  return (
    <div>
      {/* <div className="bg-[#67142D] w-full ">
        <p className="text-center text-white text-[13px] font-inter">
          Join us for the Grand Diwali Seva 2025! Light 10,000 diyas for world
          peace and prosperity
        </p>
      </div> */}
      {/* <div className="bg-[#FFF8E6] w-full ">
        <div className="px-20 py-2">
          <div className="flex max-lg:flex-col justify-between items-center ">
            <div className="">
              <SearchBar
                searchItem={searchItem}
                onSearch={(value) => setSearchItem(value)}
              />
            </div>
            
            <div>
              <div className="flex gap-6">
                <img
                  className="w-5 h-5"
                  src="/assets/facebook-icon.svg"
                  alt="FB Icon"
                />
                <img
                  className="w-5 h-5"
                  src="/assets/youtube-icon.svg"
                  alt="YouTube Icon"
                />
                <img
                  className="w-5 h-5"
                  src="/assets/twitter-icon.svg"
                  alt="X Icon"
                />
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div>
        <Navbar />
      </div>
    </div>
  );
};

export default Header;
